import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faAngleLeft, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { Form, Alert, InputGroup } from "react-bootstrap";
import { Link } from "react-router-dom";
import AkasbLogo from "../../assets/img/logo_akasb.png";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [erro, setErro] = useState("");
    const [sucesso, setSucesso] = useState("");
    const [loading, setLoading] = useState(false);

    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    const handleRecover = async (e) => {
        e.preventDefault();
        setErro(""); setSucesso(""); setLoading(true);
        try {
            const response = await fetch(`${API_BASE_URL}/auth/forgot-password`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email })
            });
            if (!response.ok) {
                const errorData = await response.text();
                throw new Error(errorData || "O email introduzido não foi encontrado.");
            }
            setSucesso("Se o email existir no sistema, receberá as instruções em breve.");
        } catch (err) {
            setErro(err.message);
        } finally { setLoading(false); }
    };

    return (
        <main style={{ minHeight: "100vh", background: "linear-gradient(135deg, #1e1d45 0%, #2d2c6b 100%)", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}>
            <div style={{ width: "100%", maxWidth: 420 }}>
                {/* Logo */}
                <div style={{ textAlign: "center", marginBottom: 32 }}>
                    <img src={AkasbLogo} alt="AKASB" style={{ width: 68, marginBottom: 14 }} />
                    <div style={{ color: "white", fontSize: 22, fontWeight: 900, letterSpacing: 2, fontFamily: "'Anton', sans-serif" }}>AKASB</div>
                </div>

                {/* Card */}
                <div style={{ background: "white", borderRadius: 20, padding: "36px 32px", boxShadow: "0 24px 60px rgba(0,0,0,0.3)" }}>
                    {/* Ícone decorativo */}
                    <div style={{ width: 56, height: 56, borderRadius: 16, background: "rgba(30,29,69,0.08)", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 20 }}>
                        <FontAwesomeIcon icon={faPaperPlane} style={{ fontSize: 22, color: "#1e1d45" }} />
                    </div>

                    <h2 style={{ fontWeight: 800, fontSize: 22, color: "#1e1d45", marginBottom: 4 }}>Recuperar Password</h2>
                    <p style={{ color: "#9ca3af", fontSize: 14, marginBottom: 28 }}>
                        Introduza o seu email e enviaremos um link de recuperação.
                    </p>

                    {erro && <Alert variant="danger" style={{ borderRadius: 12, fontSize: 14 }}>{erro}</Alert>}
                    {sucesso && (
                        <div style={{ background: "#f0fdf4", border: "1.5px solid #bbf7d0", borderRadius: 12, padding: "14px 16px", marginBottom: 20 }}>
                            <div style={{ color: "#166534", fontSize: 14, fontWeight: 600 }}>Email enviado!</div>
                            <div style={{ color: "#4ade80", fontSize: 13, marginTop: 4 }}>{sucesso}</div>
                        </div>
                    )}

                    {!sucesso && (
                        <Form onSubmit={handleRecover}>
                            <Form.Group className="mb-4">
                                <Form.Label style={{ fontWeight: 600, fontSize: 13, color: "#374151" }}>Email de Utilizador</Form.Label>
                                <InputGroup>
                                    <InputGroup.Text style={{ background: "#f8f9fa", border: "1.5px solid #e9ecef", borderRight: "none" }}>
                                        <FontAwesomeIcon icon={faEnvelope} style={{ color: "#9ca3af" }} />
                                    </InputGroup.Text>
                                    <Form.Control required type="email" placeholder="o.seu@email.com" value={email} onChange={e => setEmail(e.target.value)}
                                        style={{ border: "1.5px solid #e9ecef", borderLeft: "none", height: 50, fontSize: 15, background: "#f8f9fa" }} />
                                </InputGroup>
                            </Form.Group>

                            <button type="submit" disabled={loading} style={{ width: "100%", height: 50, background: loading ? "#6b7280" : "#1e1d45", border: "none", borderRadius: 12, color: "white", fontWeight: 700, fontSize: 15, cursor: loading ? "not-allowed" : "pointer" }}>
                                {loading ? "A processar..." : "Enviar Email de Recuperação"}
                            </button>
                        </Form>
                    )}

                    {sucesso && (
                        <Link to="/connect/login" style={{ display: "block", textAlign: "center", marginTop: 16 }}>
                            <button style={{ width: "100%", height: 50, background: "#1e1d45", border: "none", borderRadius: 12, color: "white", fontWeight: 700, fontSize: 15, cursor: "pointer" }}>
                                Voltar ao Login
                            </button>
                        </Link>
                    )}
                </div>

                <div style={{ textAlign: "center", marginTop: 24 }}>
                    <Link to="/connect/login" style={{ color: "rgba(255,255,255,0.45)", fontSize: 13, textDecoration: "none", display: "inline-flex", alignItems: "center", gap: 6 }}>
                        <FontAwesomeIcon icon={faAngleLeft} /> Voltar ao Login
                    </Link>
                </div>
            </div>
        </main>
    );
};

export default ForgotPassword;
